import PartnershipBranding from './PartnershipBranding';

export default PartnershipBranding;
